import { http } from 'services/http';
import type { DocumentSignedUrlRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

interface IGetClientInsuranceLinkVariables {
  clientId: number;
  insuranceId: number;
}

export const useGetClientInsuranceLink = () => {
  return useMutationBase<DocumentSignedUrlRes, unknown, IGetClientInsuranceLinkVariables>({
    mutationFn: async ({ clientId, insuranceId }) => {
      const { data } = await http.get<DocumentSignedUrlRes>(`/v1/clients/${clientId}/insurance/${insuranceId}/link`);

      return data;
    },
  });
};
